import KeK from "../assets/images/carousel/kek.png";
import Mondiale from "../assets/images/carousel/mondiale.png";
import Martins from "../assets/images/carousel/martins.png";
import Abrappaa from "../assets/images/carousel/abrappaa.png";
import Nnegocios from "../assets/images/carousel/nnegocios.png";

export const images = [KeK, Mondiale, Martins, Abrappaa, Nnegocios];
